import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Colors } from '@/theme';

const useStyles = makeStyles((theme) =>
  createStyles({
    input: {
      paddingLeft: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    addButtonWrapper: {
      backgroundColor: Colors.WHITE,
      position: 'absolute',
      bottom: 0,
      left: 0,
      borderWidth: 1,
      borderColor: Colors.DISABLED,
      borderStyle: 'solid',
      borderBottomLeftRadius: theme.spacing(1),
      borderBottomRightRadius: theme.spacing(1),
      borderTopRightRadius: theme.spacing(1),
      borderTopLeftRadius: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        bottom: 0,
        borderBottomLeftRadius: theme.spacing(2),
        borderBottomRightRadius: theme.spacing(2),
        borderTopRightRadius: theme.spacing(0),
        borderTopLeftRadius: theme.spacing(0),
      },
    },
    addButton: {
      textTransform: 'none',
      marginRight: theme.spacing(3),
    },
  })
);

export default useStyles;
